<template>
	<div>
		<pui-modal-dialog-form
			:overflow="false"
			:modelName="modelName"
			:onOk="onOkDisable"
			:dialogName="dialogNameEnableVessel"
			:titleText="$t('portcalls1.titleText')"
			:widthDialog="800"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							:id="`portcalls-observations`"
							v-model="data.modalData.observations"
							:label="$t('modal.version_remarks')"
							:disabled="formDisabled"
							toplabel
							required
							maxlength="256"
						></pui-text-area>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:overflow="false"
			:titleText="$t('action.modifeta')"
			:modelName="modelName"
			:dialogName="dialogNameModifEta"
			v-model="modalData"
			:widthDialog="800"
			:onOk="onOkModifEta"
			:onShow="onShoModifEta"
		>
			<template slot="message">
				<v-flex xs12 md6>
					<pui-date-field
						:id="`eta${idSufix}`"
						:label="$t('modal.eta')"
						v-model="modalData.eta"
						toplabel
						required
						time
						:max="modalData.etd"
						:min="new Date()"
					></pui-date-field>
				</v-flex>
				<v-flex xs12 md8>
					<pui-checkbox
						:id="`etaconfirmed${idSufix}`"
						:label="$t('modal.etaconfirmed')"
						v-model="modalData.etaconfirmed"
						true-value="1"
						false-value="0"
						:disabled="dissableCheck"
					></pui-checkbox>
				</v-flex>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:overflow="false"
			:titleText="$t('action.updateanchorage')"
			:modelName="modelName"
			:dialogName="dialogNameUpdateAnchorage"
			v-model="modalData"
			:widthDialog="800"
			:onOk="onOkUpdateAnchorage"
		>
			<template slot="message">
				<v-row style="margin-top: 35px">
					<v-flex xs12 lg6 x6>
						<pui-date-field
							:id="`arrivalata-${modelName}`"
							:label="$t('portcalls.arribalATA')"
							v-model="modalData.arrataanchorage"
							toplabel
							time
							:max="new Date()"
						></pui-date-field>
					</v-flex>
					<v-flex xs12 md12 lg6 x6>
						<pui-date-field
							:id="`arrivalatd-${modelName}`"
							:label="$t('portcalls.arrivalATD')"
							v-model="modalData.arratdanchorage"
							toplabel
							time
							:min="modalData.arrataanchorage"
							:max="new Date()"
						></pui-date-field>
					</v-flex>
					<v-flex xs12 md12 lg6 x6>
						<pui-date-field
							:id="`departureata-${modelName}`"
							:label="$t('portcalls.depatureATA')"
							v-model="modalData.depataanchorage"
							toplabel
							time
							:max="new Date()"
						></pui-date-field>
					</v-flex>

					<v-flex xs12 md12 lg6 x6>
						<pui-date-field
							:id="`depatureatd-${modelName}`"
							:label="$t('portcalls.departureATD')"
							v-model="modalData.depatdanchorage"
							toplabel
							time
							:min="modalData.depataanchorage"
							:max="new Date()"
						></pui-date-field>
					</v-flex>
					<v-flex xs12 md12 lg6 x6>
						<pui-date-field
							:id="`departureata-${modelName}`"
							:label="$t('portcalls.emeataanchorage')"
							v-model="modalData.emeataanchorage"
							toplabel
							time
							:max="new Date()"
						></pui-date-field>
					</v-flex>

					<v-flex xs12 md12 lg6 x6>
						<pui-date-field
							:id="`depatureatd-${modelName}`"
							:label="$t('portcalls.emeatdanchorage')"
							v-model="modalData.emeatdanchorage"
							toplabel
							time
							:min="modalData.emeataanchorage"
							:max="new Date()"
						></pui-date-field>
					</v-flex>

					<v-flex xs12 md12 lg6 x6>
						<pui-date-field
							:id="`operationsata-${modelName}`"
							:label="$t('portcalls.operationsata')"
							v-model="modalData.operationsataanchorage"
							toplabel
							time
							:max="new Date()"
						></pui-date-field>
					</v-flex>

					<v-flex xs12 md12 lg6 x6>
						<pui-date-field
							:id="`operationsatd-${modelName}`"
							:label="$t('portcalls.operationsatd')"
							v-model="modalData.operationsatdanchorage"
							toplabel
							time
							:min="modalData.operationsataanchorage"
							:max="new Date()"
						></pui-date-field>
					</v-flex>
				</v-row>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:overflow="false"
			:titleText="$t('action.modifetd')"
			:modelName="modelName"
			:dialogName="dialogNameModifEtd"
			v-model="modalData"
			:widthDialog="800"
			:onOk="onOkModifEtd"
		>
			<template slot="message">
				<v-flex xs12 md6>
					<pui-date-field :id="`etd${idSufix}`" :label="$t('modal.etd')" v-model="modalData.etd" toplabel required time></pui-date-field>
				</v-flex>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:titleText="$t('action.confirmPortCall')"
			:modelName="modelName"
			:dialogName="dialogNameconfirmPortCall"
			:widthDialog="800"
			:onOk="onOkconfirmPortCall"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						{{ $t('action.confirmPortCallmesasage') }}
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:titleText="$t('action.rejectPortCall')"
			:modelName="modelName"
			:dialogName="dialogNamerejectPortCall"
			:widthDialog="800"
			:onOk="onOkrejectPortCall"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							:id="`portcalls-rejectionreason`"
							v-model="data.modalData.rejectionreason"
							:label="$t('modal.rejectionreason')"
							toplabel
							required
							maxlength="256"
						></pui-text-area>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:titleText="$t('confirmDeparture.title')"
			:modelName="modelName"
			:dialogName="dialogNameconfirmDeparture"
			:widthDialog="800"
			:onOk="onOkconfirmDeparture"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						{{ $t('confirmDeparture.label') }}
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('action.shipAgencyTransfer')"
			:modelName="modelName"
			:dialogName="dialogNameShipAgencyTransfer"
			:onOk="onOktransferShipAgency"
			:onShow="onShowTransferShipAgency"
			:overflow="false"
			:widthDialog="600"
		>
			<template slot="message">
				<v-layout wrap>
					<v-flex xs12 v-show="false">
						<pui-select
							id="portcode"
							attach="portcode"
							:label="this.$t('portcalls.portcode')"
							toplabel
							v-model="newModel"
							modelName="mlocalports"
							reactive
							disabled
							clearable
							required
							:modelFormMapping="{ countrycode: 'countrycode', portcode: 'portcode' }"
							:itemsToSelect="itemsToSelectPortcode"
							:itemValue="['countrycode', 'portcode']"
							:itemText="(item) => `${item.countrycode}${item.portcode} - ${item.portdescription}`"
							:order="{ locode: 'asc' }"
							@change="changePortCode($event, modalData)"
						></pui-select>
					</v-flex>
					<v-flex xs12>
						<pui-select
							:id="`shipagendid-${modelName}`"
							:attach="`shipagendid-${modelName}`"
							:label="$t('portcalls.shipagendid')"
							toplabel
							clearable
							reactive
							required
							v-model="newModel"
							modelName="vlupagency"
							:itemsToSelect="itemsToSelectShipagendid"
							:modelFormMapping="{ locode: 'locode' }"
							:itemValue="['descripcion']"
							:itemText="(item) => `${item.descripcion}`"
							:order="{ descripcion: 'asc' }"
							:fixedFilter="fixedFilterAgent"
							@change="changeAgent($event, modalData)"
						></pui-select>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('action.confirmTransfer')"
			:modelName="modelName"
			:dialogName="dialogNameConfirmTransfer"
			:widthDialog="800"
			:onOk="onOkConfirmTransfer"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						{{ $t('shipagencytransfers.confirmTransferMessage') }}
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('action.rejectTransfer')"
			:modelName="modelName"
			:dialogName="dialogNameRejectTransfer"
			:widthDialog="800"
			:onOk="onOkRejectTransfer"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							:id="`shipagencytransfers-rejectionreason`"
							v-model="data.modalData.rejectionreason"
							:label="$t('shipagencytransfers.rejectionreason')"
							toplabel
							required
						></pui-text-area>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('action.emergencystart')"
			:modelName="modelName"
			:dialogName="dialogNameEmergencyStart"
			:widthDialog="900"
			:onOk="onOkEmergencyStart"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-row dense>
						<v-flex xs12 md12>
							<pui-date-field
								:id="`emergencyprocess-datestart`"
								:label="$t('emergencyprocess.datestart')"
								v-model="data.modalData.datestart"
								toplabel
								required
								time
								:max="new Date()"
							></pui-date-field>
						</v-flex>

						<v-flex xs12 md12>
							<pui-text-area
								:id="`emergencyprocess-remarksstart`"
								v-model="data.modalData.remarksstart"
								:label="$t('emergencyprocess.remarksstart')"
								toplabel
								required
							></pui-text-area>
						</v-flex>
					</v-row>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:titleText="$t('action.emergencyend')"
			:modelName="modelName"
			:dialogName="dialogNameEmergencyEnd"
			:widthDialog="900"
			:onOk="onOkEmergencyEnd"
			:onShow="onShowEmergencyEnd"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-row dense>
						<v-flex xs12 md12>
							<pui-date-field
								:id="`emergencyprocess-dateend`"
								:label="$t('emergencyprocess.dateend')"
								v-model="data.modalData.dateend"
								toplabel
								required
								time
								:min="emergencystartdate"
							></pui-date-field>
						</v-flex>

						<v-flex xs12 md12>
							<pui-text-area
								:id="`emergencyprocess-remarksend`"
								v-model="data.modalData.remarksend"
								:label="$t('emergencyprocess.remarksend')"
								toplabel
								required
							></pui-text-area>
						</v-flex>
					</v-row>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:titleText="$t('puiaction.audit')"
			:modelName="modelName"
			disableCancel
			:okText="$t('Close')"
			:dialogName="dialogNamepuiAuditAction"
			@input="onAuditModalChange"
		>
			<template slot="message" slot-scope="data" :widthDialog="1820">
				<v-layout wrap class="justify-center"
					><div class="puiAuditFormtable">
						<!-- GRID PRINCIPAL -->
						<div class="audit-grid">
							<table>
								<thead>
									<tr>
										<th>{{ $t('puiauditExtended.datetime') }}</th>
										<th>{{ $t('puiauditExtended.type') }}</th>
										<th>{{ $t('puiauditExtended.nameAgency') }}</th>
										<th>{{ $t('puiauditExtended.vat') }}</th>
										<th>{{ $t('puiauditExtended.address') }}</th>
										<th>{{ $t('puiauditExtended.user') }}</th>
										<th>{{ $t('puiauditExtended.email') }}</th>
										<th>{{ $t('puiauditExtended.phone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(record, idx) in data.modalData"
										:key="record.id || idx"
										@click="onSelectRecord(record)"
										:class="{ selected: selectedRecord && selectedRecord.id === record.id }"
									>
										<td>{{ formatDate(record.datetime) }}</td>
										<td>{{ record.type }}</td>
										<td>{{ record.descripcion }}</td>
										<td>{{ record.documento }}</td>
										<td>{{ record.direccion }}</td>
										<td>{{ record.username }}</td>
										<td>{{ record.email }}</td>
										<td>{{ record.telefono }}</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!-- DETALLE DEL REGISTRO SELECCIONADO (cabeceras siempre visibles)-->
						<div class="audit-details">
							<table>
								<thead>
									<tr>
										<th>{{ $t('puiaudit.attribute') }}</th>
										<th v-if="selectedRecord && selectedRecord.type === 'update'">{{ $t('puiaudit.oldValue') }}</th>
										<th>{{ $t('puiaudit.newValue') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in content" :key="index">
										<td>
											<span>{{ item.attribute }}</span>
										</td>
										<template v-if="selectedRecord.type === 'update'">
											<td v-if="item.oldValue && Array.isArray(item.oldValue)">
												<tr v-for="(internalItem, internalIndex) in item.oldValue" :key="internalIndex">
													<pui-audit-item :model="internalItem"></pui-audit-item>
												</tr>
											</td>
											<pui-audit-item v-else :model="item.oldValue"></pui-audit-item>
										</template>
										<td v-if="item.value && Array.isArray(item.value)">
											<tr v-for="(internalItem, internalIndex) in item.value" :key="internalIndex">
												<pui-audit-item :model="internalItem"></pui-audit-item>
											</tr>
										</td>
										<pui-audit-item v-else :model="item.value"></pui-audit-item>
									</tr>
								</tbody>
							</table>
						</div></div
				></v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:overflow="false"
			:titleText="$t('action.anchorageoperations.requestArrival')"
			:modelName="modelanchorageoperations"
			:dialogName="'anchorageRequestArrival'"
			v-model="modalData"
			:widthDialog="700"
			:onOk="onOkAnchorageRequestArrival"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="anchorage-arrival-observations"
							v-model="data.modalData.arrivalobservations"
							:label="$t('anchorageoperations.observationsArrival')"
							toplabel
							maxlength="512"
						></pui-text-area>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog-form
			:overflow="false"
			:titleText="$t('action.anchorageoperations.requestDeparture')"
			:modelName="modelanchorageoperations"
			:dialogName="'anchorageRequestDeparture'"
			v-model="modalData"
			:widthDialog="700"
			:onOk="onOkAnchorageRequestDeparture"
		>
			<template slot="message" slot-scope="data">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						<pui-text-area
							id="anchorage-departure-observations"
							v-model="data.modalData.departureobservations"
							:label="$t('anchorageoperations.observationsDeparture')"
							toplabel
							maxlength="512"
						></pui-text-area>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
import PuiAuditItem from 'pui9-datatables/src/components/puiaudit/PuiAuditItem.vue';
export default {
	name: 'portcallsmodals',
	components: {
		PuiAuditItem
	},
	data() {
		return {
			modal: {
				enableVessel: {
					labelText: 'prueba',
					disableOk: false,
					show: false
				}
			},
			modalData: {},
			model: 'portcalls',
			modelemergencyprocess: 'emergencyprocess',
			modelanchorageoperations: 'anchorageoperations',
			dialogNameEnableVessel: 'enableVessel',
			dialogNameModifEta: 'modifeta',
			dialogNameModifEtd: 'modifetd',
			dialogNameUpdateAnchorage: 'updateanchorage',
			dialogNameImmigrationValidateDocs: 'arrvalidatedocs',
			dialogNameconfirmPortCall: 'confirmPortCall',
			dialogNamerejectPortCall: 'rejectPortCall',
			dialogNameconfirmDeparture: 'confirmDeparture',
			dialogNameShipAgencyTransfer: 'shipAgencyTransfer',
			dialogNameConfirmTransfer: 'approveTransfer',
			dialogNameRejectTransfer: 'rejectTransfer',
			dialogNameEmergencyStart: 'emergencyStart',
			dialogNameEmergencyEnd: 'emergencyEnd',
			dialogNamepuiAuditAction: 'viewAuditExt',
			dialogNameAnchorageRequestArrival: 'anchorageRequestArrival',
			dialogNameAnchorageRequestDeparture: 'anchorageRequestDeparture',
			idSufix: `-${this.modelName}-modal`,
			dissableCheck: '',
			observations: '',
			consigneeList: [],
			consigneeKey: 0,
			newModel: {
				countrycode: null,
				portcode: null
			},
			valuesModel: 0,
			shipagendname: null,
			type: 'insert',
			content: [],
			selectedRecord: null
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	mounted() {
		this.subscribeToModalDialogEvent();
	},
	computed: {
		itemsToSelectPortcode() {
			return [{ countrycode: this.newModel.countrycode, portcode: this.newModel.portcode }];
		},
		itemsToSelectShipagendid() {
			return [{ codorg: this.newModel.shipagendid, descripcion: this.newModel.shipagendname }];
		},
		fixedFilterAgent() {
			const locode = (this.newModel.countrycode || '') + (this.newModel.portcode || '');
			return {
				rules: [
					{ field: 'locode', op: 'eq', data: locode },
					{ field: 'descripcion', op: 'ne', data: this.shipagendname }
				],
				groupOp: 'and'
			};
		}
	},
	destroyed() {
		this.$puiEvents.$off(`pui-modalDialog-disableVessel-${this.modelName}-ok`);
		this.$puiEvents.$off(`pui-modalDialog-disableVessel-${this.modelName}-cancel`);
		this.$puiEvents.$off(`pui-modalDialog-disableVessel-${this.modelName}-show`);
		this.$puiEvents.$off(`pui-modalDialog-enableVessel-${this.modelName}-ok`);
		this.$puiEvents.$off(`pui-modalDialog-enableVessel-${this.modelName}-cancel`);
		this.$puiEvents.$off(`pui-modalDialog-enableVessel-${this.modelName}-show`);
	},
	methods: {
		parsedAuditContent(record) {
			if (!record || !record.content) return [];
			if (typeof record.content === 'string') {
				try {
					return JSON.parse(record.content);
				} catch (e) {
					return [];
				}
			}
			return Array.isArray(record.content) ? record.content : [];
		},
		formatDate(value) {
			if (!value) return '';
			return this.$dateTimeUtils.getLocalFormattedDate(value, `${this.$store.getters.dateFormat} ${this.$store.getters.timeFormat}`);
		},
		onSelectRecord(record) {
			if (this.selectedRecord && this.selectedRecord.id === record.id) {
				this.selectedRecord = null;
			} else {
				this.selectedRecord = record;
			}
		},
		onAuditModalChange(val) {
			if (!val.showDialog) {
				this.selectedRecord = null;
				this.content = [];
			}
		},
		onShowTransferShipAgency(modalData) {
			this.shipagendname = modalData.registries.shipagendname;
			this.newModel.countrycode = modalData.registries.countrycode;
			this.newModel.portcode = modalData.registries.portcode;
		},
		changeAgent(e) {
			if (e != null) {
				this.newModel.shipagendname = e.descripcion;
				this.newModel.shipagendid = e.codorg;
			}
		},
		changePortCode(e) {
			if (e != null) {
				this.valuesModel = 1;
				const urlEquipmentServices = '/gestaut/getUserConsignee';
				const params = {
					countrycode: e.countrycode,
					portcode: e.portcode
				};
				this.$puiRequests.getRequest(urlEquipmentServices, params, (response) => this.setConsignee(response.data));
			} else {
				this.newModel.portcode = null;
				this.newModel.countrycode = null;
				this.valuesModel = 0;
			}
		},
		setConsignee(responseConsignee = []) {
			this.consigneeList = [];
			this.consigneeList = responseConsignee.map((c) => {
				if (c.descripcion != this.shipagendname) {
					return {
						codorg: c.codorg,
						descripcion: c.descripcion,
						label: c.descripcion
					};
				}
			});
			this.consigneeKey++;
		},
		onOkDisable(modalData) {
			const url = '/portcalls/cancelPortcalls';
			const title = this.$puiI18n.t('cancelPortcall.title');
			const params = {
				portcallid: modalData.headerPk.portcallid,
				observations: modalData.observations
			};

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					url,
					params,
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, true);
						resolve(false);
					},
					null
				);
			});
		},
		onOkrejectPortCall(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				rejectionreason: modalData.rejectionreason
			};
			const urlController = this.$store.getters.getModelByName(this.modelName).url.rejectPortCall;
			const title = this.$puiI18n.t('rejectPortCall.title');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,

					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		onOkconfirmPortCall(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid
			};
			const urlController = this.$store.getters.getModelByName(this.modelName).url.confirmPortCall;
			const title = this.$puiI18n.t('confirmPortCall.title');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,

					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		subscribeToModalDialogEvent() {
			// Modal Disable
			this.$puiEvents.$on(`pui-modalDialog-disableVessel-${this.modelName}-ok`, () => {
				if (this.$refs.validateDisable.validate()) {
					this.setShowDisableVessel(false);
					this.$puiEvents.$emit('pui-action-runAction-' + this.modelName);
				}
			});
			this.$puiEvents.$on(`pui-modalDialog-disableVessel-${this.modelName}-cancel`, () => {
				this.setShowDisableVessel(false);
				this.$puiEvents.$off('pui-action-runAction-' + this.modelName);
				this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
				this.modal.disableVessel.fecfinvig = null;
			});
			this.$puiEvents.$on(`pui-modalDialog-disableVessel-${this.modelName}-show`, (data) => {
				this.parentModelPk = {
					codbuque: data.codbuque
				};
				this.setShowDisableVessel(true);
			});
			// Modal enable
			this.$puiEvents.$on(`pui-modalDialog-enableVessel-${this.modelName}-ok`, () => {
				this.setShowEnableVessel(false);
				this.$puiEvents.$emit('pui-action-runAction-' + this.modelName);
			});
			this.$puiEvents.$on(`pui-modalDialog-enableVessel-${this.modelName}-cancel`, () => {
				this.setShowEnableVessel(false);
				this.$puiEvents.$off('pui-action-runAction-' + this.modelName);
			});
			this.$puiEvents.$on(`pui-modalDialog-enableVessel-${this.modelName}-show`, () => {
				this.setShowEnableVessel(true);
			});
		},
		setShowDisableVessel(action) {
			this.modal.disableVessel.show = action;
		},
		setShowEnableVessel(action) {
			this.modal.enableVessel.show = action;
		},
		setShowmodifeta(action) {
			this.modal.modifeta.show = action;
		},
		onOkUpdateAnchorage(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				arrataanchorage: modalData.arrataanchorage,
				arratdanchorage: modalData.arratdanchorage,
				depataanchorage: modalData.depataanchorage,
				depatdanchorage: modalData.depatdanchorage,
				emeataanchorage: modalData.emeataanchorage,
				emeatdanchorage: modalData.emeatdanchorage,
				operationsataanchorage: modalData.operationsataanchorage,
				operationsatdanchorage: modalData.operationsatdanchorage
			};

			const urlController = this.$store.getters.getModelByName(this.model).url.updateanchorage;

			const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$t('action.updateanchorage');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.model);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiNotify.error(message, title, true);
						resolve(false);
					}
				);
			});
		},
		onOkModifEta(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				eta: modalData.eta,
				etaconfirmed: modalData.etaconfirmed
			};

			const urlController = this.$store.getters.getModelByName(this.model).url.modifeta;

			const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$t('action.modifeta');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.model);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiNotify.error(message, title, true);
						resolve(false);
					}
				);
			});
		},
		onOkModifEtd(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				etd: modalData.etd
			};

			const urlController = this.$store.getters.getModelByName(this.model).url.modifetd;

			const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$t('action.modifetd');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.model);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiNotify.error(message, title, true);
						resolve(false);
					}
				);
			});
		},
		onShoModifEta(modalData) {
			if (modalData.etaconfirmed == '1') {
				this.dissableCheck = true;
			} else {
				this.dissableCheck = false;
			}
		},
		onOkconfirmDeparture(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid
			};
			const urlController = this.$store.getters.getModelByName(this.modelName).url.confirmDeparture;
			const title = this.$puiI18n.t('confirmDeparture.title');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,

					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		onOktransferShipAgency(modalData) {
			const title = this.$puiI18n.t('action.shipAgencyTransfer');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					this.$store.getters.getModelByName('shipagencytransfers').url.transferShipAgency,
					{
						portcallid: modalData.registries.portcallid,
						shipagendid: this.newModel.shipagendid,
						shipagendname: this.newModel.shipagendname,
						shipagendorigin: modalData.registries.shipagendname,
						shipagendoriginid: modalData.registries.shipagendid
					},
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		onOkConfirmTransfer(modalData) {
			const title = this.$puiI18n.t('action.confirmTransfer');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					this.$store.getters.getModelByName('shipagencytransfers').url.confirmTransfer,
					{
						portcallid: modalData.registries.portcallid
					},
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		onOkRejectTransfer(modalData) {
			const title = this.$puiI18n.t('action.rejectTransfer');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					this.$store.getters.getModelByName('shipagencytransfers').url.rejectTransfer,
					{
						portcallid: modalData.registries.portcallid,
						rejectionreason: modalData.rejectionreason
					},
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		onOkEmergencyStart(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				datestart: modalData.datestart,
				remarksstart: modalData.remarksstart
			};

			const urlController = this.$store.getters.getModelByName(this.modelemergencyprocess).url.emergencystart;

			const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$t('action.emergencystart');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.model);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		onOkEmergencyEnd(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				dateend: modalData.dateend,
				remarksend: modalData.remarksend
			};

			const urlController = this.$store.getters.getModelByName(this.modelemergencyprocess).url.emergencyend;

			const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$t('action.emergencyend');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.model);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					}
				);
			});
		},
		onShowEmergencyEnd(modalData) {
			this.emergencystartdate = modalData.registries.emergencystartdate;
		},
		onOkAnchorageRequestArrival(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				observations: modalData.arrivalobservations
			};

			const urlController = this.$store.getters.getModelByName(this.modelanchorageoperations).url.anchorageRequestArrival;

			const title = this.$t('anchorage.requestArrival');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						localStorage.setItem('tabFromAction', 'anchorageoperations');
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelanchorageoperations);
						// Notify Portcalls form that anchorage operations now exist and request tab open
						this.$puiEvents.$emit('setHasAnchorageOperations-' + this.model);
						this.$puiEvents.$emit('refreshAnchorageStatus-' + this.model);
						this.$puiEvents.$emit('openTab-' + this.model, 'anchorageoperations');
						// Refresh anchorage grid without reloading the whole portcall form
						this.$puiEvents.$emit('refreshGrid-' + this.modelanchorageoperations);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelanchorageoperations);
						const portcallid = modalData?.headerPk?.portcallid;
						if (portcallid) {
							const optsAnchorage = {
								model: 'anchorageoperations',
								filter: {
									groupOp: 'and',
									groups: [],
									rules: [{ field: 'portcallid', op: 'eq', data: portcallid }]
								},
								order: [{ column: 'anchorageoperationid', direction: 'desc' }],
								limit: 1
							};
							setTimeout(() => {
								this.$puiRequests.postRequest('/puisearch', optsAnchorage, (resp) => {
									const latest = resp?.data?.data?.[0];
									if (latest) {
										this.$puiEvents.$emit('onPui-selectItem-dataTable-anchorageoperations', [latest]);
										this.$puiEvents.$emit('onPui-form-afterGetData-anchorageoperations', latest);
									}
								});
							}, 500);
						}
						this.$puiNotify.success(this.$t('puiaction.notifySuccess'), title);
						resolve(true);
					},
					(e) => {
						let msg = this.$t('puiaction.notifyError');
						if (e.response && e.response.data) msg = e.response.data.message;
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelanchorageoperations);
						this.$puiNotify.error(msg, title, true);
						resolve(false);
					}
				);
			});
		},
		onOkAnchorageRequestDeparture(modalData) {
			const params = {
				portcallid: modalData.headerPk.portcallid,
				observations: modalData.departureobservations
			};

			const urlController = this.$store.getters.getModelByName(this.modelanchorageoperations).url.anchorageRequestDeparture;

			const title = this.$t('anchorage.requestDeparture');

			return new Promise((resolve) => {
				this.$puiRequests.getRequest(
					urlController,
					params,
					() => {
						localStorage.setItem('tabFromAction', 'anchorageoperations');
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelanchorageoperations);
						// Notify Portcalls form that anchorage operations now exist and request tab open
						this.$puiEvents.$emit('setHasAnchorageOperations-' + this.model);
						this.$puiEvents.$emit('refreshAnchorageStatus-' + this.model);
						this.$puiEvents.$emit('openTab-' + this.model, 'anchorageoperations');
						// Refresh anchorage grid without reloading the whole portcall form
						this.$puiEvents.$emit('refreshGrid-' + this.modelanchorageoperations);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelanchorageoperations);
						const portcallid = modalData?.headerPk?.portcallid;
						if (portcallid) {
							const optsAnchorage = {
								model: 'anchorageoperations',
								filter: {
									groupOp: 'and',
									groups: [],
									rules: [{ field: 'portcallid', op: 'eq', data: portcallid }]
								},
								order: [{ column: 'anchorageoperationid', direction: 'desc' }],
								limit: 1
							};
							setTimeout(() => {
								this.$puiRequests.postRequest('/puisearch', optsAnchorage, (resp) => {
									const latest = resp?.data?.data?.[0];
									if (latest) {
										this.$puiEvents.$emit('onPui-selectItem-dataTable-anchorageoperations', [latest]);
										this.$puiEvents.$emit('onPui-form-afterGetData-anchorageoperations', latest);
									}
								});
							}, 500);
						}
						this.$puiNotify.success(this.$t('puiaction.notifySuccess'), title);
						resolve(true);
					},
					(e) => {
						let msg = this.$t('puiaction.notifyError');
						if (e.response && e.response.data) msg = e.response.data.message;
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelanchorageoperations);
						this.$puiNotify.error(msg, title, true);
						resolve(false);
					}
				);
			});
		}
	},
	watch: {
		selectedRecord(newVal) {
			if (!newVal) {
				this.content = []; // limpia si no hay selección
			} else {
				this.content = this.parsedAuditContent(newVal); // actualiza si selecciona
			}
		}
	}
};
</script>
<style lang="postcss">
.puiAuditFormtable {
	height: 600px;
	width: 100%;
	display: flex;
	gap: 20px;
}

/* Tabla principal */
.audit-grid {
	flex: 0 0 55%; /* ancho fijo 55% */
	min-width: 400px;
	overflow-y: auto;
}

.audit-grid table {
	width: 100%;
	border-collapse: collapse;
	overflow-y: auto;
}

.audit-grid th {
	background: #f9f9f9;
	font-weight: bold;
	border: none; /* sin líneas en cabecera */
	padding: 10px;
	text-align: left;
	white-space: nowrap; /* no cortar palabras */
}

.audit-grid td {
	border: none; /* sin líneas en celdas */
	padding: 10px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: keep-all;
}

/* Zebra striping en la tabla principal */
.audit-grid tbody tr:nth-child(even) {
	background-color: #ffffff;
}
.audit-grid tbody tr:nth-child(odd) {
	background-color: #e7eef2;
}

.audit-details {
	flex: 0 0 45%; /* ancho fijo 45% */
	min-width: 300px; /* asegura que se vea en pantallas pequeñas */
	overflow-y: auto;
	overflow-x: auto;
}

.selected {
	background-color: #2f6383 !important; /* azul más oscuro */
	color: #fff;
}
.audit-details table {
	width: 100%;
	table-layout: fixed; /* asegura que no se desborde */
	border-collapse: collapse;
}

.audit-details th,
.audit-details td {
	border: 1px solid #dddddd;
	padding: 8px 10px;
	text-align: left;
	word-break: keep-all;
	white-space: normal; /* permite saltos de línea */
}

.audit-details thead th {
	position: sticky;
	top: 0;
	background: #f9f9f9; /* para que se diferencie y tape las celdas al hacer scroll */
	z-index: 2; /* que quede por encima del contenido */
}
</style>



